export const CART_QUERY = /* GraphQL */ `
  query cart($cartId: UUID!) {
    cart(id: $cartId) {
      ...cartFields
    }
  }
`;
export const ORDER_INTENT_QUERY = /* GraphQL */ `
  query orderIntent($cartId: UUID!) {
    orderIntent(id: $cartId, format: core) {
      order
    }
  }
`;
export const CHECK_VOUCHER_CODE = /* GraphQL */ `
  query checkVoucherCode($voucher: String!) {
    validateVoucher(voucher: $voucher) {
      isValid
      promotions {
        identifier
        name
        mechanism {
          value
          type
        }
      }
    }
  }
`;
export const CART_FRAGMENT = /* GraphQL */ `
  fragment priceFields on Price {
    gross
    net
    taxAmount
    currency
    discounts {
      percent
      amount
    }
  }
  fragment customerFields on Customer {
    isGuest
    identifier
    firstName
    lastName
    phone
    email
    birthDate
    externalReferences
    type
    meta
    addresses {
      type
      firstName
      lastName
      street
      postalCode
      city
      country
      phone
      email
    }
  }
  fragment cartFields on Cart {
    id
    isStale
    staleAt
    items {
      name
      images {
        url
      }
      quantity
      variant {
        sku
        attributes
        attribute(key: "innbinding")
        compareAtPrice {
          ...priceFields
        }
        price {
          ...priceFields
        }
        product {
          id
          path
        }
        name
      }
      price {
        ...priceFields
      }
    }
    updatedAt
    state
    orderId
    total {
      ...priceFields
    }
    customer {
      ...customerFields
    }
    context
    cartApiVersion: metaProperty(key: "cartApiVersion")
    universe: metaProperty(key: "universe")
    cartType: metaProperty(key: "cartType")
    freeShippingThreshold: metaProperty(key: "freeShippingThreshold")
  }
`;
